import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteConfirmationModal from "../../../components/commonComponent/DeleteConfirmationModal";
import Pagination from "../../../components/commonComponent/Pagination";
import Search from "../../../components/commonComponent/Search";
import Table from "../../../components/commonComponent/Table";
import ViewModal from "../../../components/commonComponent/ViewModal";
import useModal from "../../../hooks/useModal";
import "../../../styles/SolarStation.css";
import { deleteData } from "../../../utils/utils";
import useLoader from "../../../hooks/useLoader";

const API_URL = process.env.REACT_APP_API_URL;

const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        console.error("Invalid date:", dateString);
        return "Invalid Date";
    }
    const options = {
        year: "2-digit",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    };
    return date.toLocaleString("en-GB", options).replace(",", "").replace(/\//g, "-");
};

const columns = [
//   { header: "Image", accessor: "image" },
  { header: "Name", accessor: "name" },
  { header: "Address", accessor: "address" },
  { header: "Description", accessor: "description" },
  { header: "Date", accessor: "date" }, // Use "formattedDate" if you format it
  { header: "Capacity", accessor: "capacity" },
  { header: "Details", accessor: "details" },
];


const ITEMS_PER_PAGE = 10;

const TestiMonial = () => {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { loading, showLoader, hideLoader } = useLoader();

    const {
        showDeleteModal,
        showViewModal,
        selectedItem,
        handleOpenDeleteModal,
        handleCloseDeleteModal,
        handleOpenViewModal,
        handleCloseViewModal,
    } = useModal();

    const fetchInterviews = async () => {
        try {
            showLoader();
            const response = await fetch(
                `${API_URL}/testimonial/getAllTestimonials?page=${currentPage}&limit=${ITEMS_PER_PAGE}&search=${searchTerm}`
            );
            const result = await response.json();

            if (response.ok) {
                const sortedData = result
                    .map((item) => ({
                        ...item,
                        formattedDate: formatDate(item.interviewDate),
                    }))
                    .sort((a, b) => new Date(b.interviewDate) - new Date(a.interviewDate));

                setData(sortedData);
                setTotalPages(result.totalPages);
            } else {
                setError(result.error);
            }
        } catch (error) {
            setError("Failed to fetch data");
        } finally {
            hideLoader();
        }
    };

    useEffect(() => {
        if (searchTerm.length >= 2 || searchTerm === "") {
            fetchInterviews();
        }
    }, [currentPage, searchTerm]);

    const handleSearch = (term) => {
        if (term.length >= 2) {
            setSearchTerm(term);
            setCurrentPage(1);
        } else if (term.length === 0) {
            setSearchTerm("");
            setCurrentPage(1);
        }
    };

    const handleDeleteConfirm = () => {
        deleteData(`${API_URL}/testimonial/deleteTestimonial`, selectedItem._id, setError)
            .then(() => {
                setData((prevData) =>
                    prevData.filter((item) => item._id !== selectedItem._id)
                );
                toast.success("Deleted successfully");
                fetchInterviews();
            })
            .catch((error) => {
                setError(error);
                toast.error("Error deleting data");
            });
        handleCloseDeleteModal();
    };

    const fieldsToShow = {
        Name: "name",
        Details: "details",
        Capacity: "capacity",
        Date: "date",
        Description: "description",
        Address: "address"
    };

    return (
        <div>
            <h2 className="capitalize font-bold text-[24px] mb-4">TestiMonial List</h2>

            <div className="flex justify-between items-center shadow-md px-8 py-[10px] rounded-md bg-[#fff] text-base mb-4">
                <div className="flex items-center">
                    <div className="search-filter-container">
                        <Search
                            searchFields={["Name", "Company", "Website"]}
                            onSearch={handleSearch}
                        />
                    </div>
                </div>

                <Link
                    to="/testimonial/add"
                    className="inline-flex items-center justify-center rounded-md border border-white px-4 py-1.5 text-center font-medium text-white bg-[#1C2434] hover:bg-opacity-90"
                >
                    Add TestiMonial
                </Link>
            </div>

            <div>
                <Table
                    columns={columns}
                    data={data}
                    showIndex={true}
                    onDelete={handleOpenDeleteModal}
                    onUpdate={(item) => navigate(`/testimonial/edit/${item._id}`)}
                    onView={handleOpenViewModal}
                    actions={{
                        showView: true,
                        showEdit: true,
                        showDelete: true,
                    }}
                    loading={loading}
                />
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                />
            </div>

            <DeleteConfirmationModal
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onConfirm={handleDeleteConfirm}
            />

            <ViewModal
                show={showViewModal}
                onHide={handleCloseViewModal}
                data={selectedItem}
                fields={fieldsToShow}
            />
        </div>
    );
};

export default TestiMonial;
